import TravelRuleTableItem from './TravelRuleTableItem'

export default TravelRuleTableItem
